import React from "react";

import errorUrl from "../../images/icons/error.svg";

const ErrorIcon = () => <img src={errorUrl} alt="Error Icon" />;

export default ErrorIcon;
